<template>
  <nav :class="classes" class="navbar navbar-expand-lg">
    <div class="container">
      <div class="navbar-translate">
        <!--<i class="fas fa-user-plus jipvio-m-i"></i>-->
        <slot v-bind="slotData"></slot>
        <navbar-toggle-button
          :toggled="showMenu"
          @click.native.stop="toggle"
        ></navbar-toggle-button>
      </div>
      <div
        class="collapse navbar-collapse show jipvio-main-nav jipvio-m-menu"
        data-color="orange"
        id="navigation"
      >
        <ul class="navbar-nav jipvio-ul jipvio-m-ul ml-auto" style="zIndex: 1;">
          <li @click="handleSelect('아파트')" class="jipvio-main-menu">
            <a href="#">아파트</a>
            <hoverunder></hoverunder>
          </li>
          <li @click="handleSelect('빌라')" class="jipvio-main-menu">
            <a href="#">빌라</a>
            <hoverunder></hoverunder>
          </li>
          <li @click="handleSelect('주택')" class="jipvio-main-menu">
            <a href="#">주택</a>
            <hoverunder></hoverunder>
          </li>
          <li @click="handleSelect('오피스텔')" class="jipvio-main-menu">
            <a href="#">오피스텔</a>
            <hoverunder></hoverunder>
          </li>
          <li @click="handleSelect('원룸')" class="jipvio-main-menu">
            <a href="#">원룸</a>
            <hoverunder></hoverunder>
          </li>
        </ul>
        <ul
          class="navbar-nav jipvio-ul"
          :class="menuClasses"
          v-click-outside="close"
          id="jipvio-ul-3"
        >
          <li
            class="jipvio-main-menu fl m-sign-login-l"
            v-show="sessionAuthToken === null"
            @click="setNav(false)"
          ></li>
          <li
            class="jipvio-main-menu fl m-sign-login-l"
            v-show="sessionAuthToken === null"
            @click="validate()"
          >
            <a>회원가입</a>
            <!-- <router-link to="/signup"> -->
            <!-- <i class="fas fa-user"></i> -->
            <!-- 회원가입</router-link
            > -->
            <!-- </li> -->
          </li>

          <li id="jipvio-space" v-show="sessionAuthToken === null">
            <a class="m-0"> | </a>
          </li>
          <li class="jipvio-main-menu fl m-sign-login-r">
            <!-- 로그인 개방시 삭제 -->
            <router-link to="/" v-show="sessionAuthToken === null">
              <span @click="validate()">로그인</span>
            </router-link>
            <!-- 로그인 개방시 삭제 -->

            <!-- <router-link to="/login" v-show="sessionAuthToken === null"> -->
            <!--<i class="fas fa-sign-in-alt"></i>-->
            <!-- <span
                @click="setNav(false)"
                >로그인</span
              > -->
            <!-- </router-link> -->
            <drop-down
              tag="li"
              position="right"
              class="nav-item"
              id="jipvio-user"
              icon="now-ui-icons users_circle-08"
              v-show="sessionAuthToken !== null"
            >
              <a class="dropdown-item" href="#" @click="logout()">로그아웃</a>
              <a class="dropdown-item" href="#" @click="myPage()">마이페이지</a>
            </drop-down>
            <!-- <a
              class="nav-link btn btn-primary jipvio-btn"
              v-show="sessionAuthToken !== null"
              @click="logout"
            >
              <p>로그아웃</p>
            </a> -->
          </li>
          <!--<slot name="navbar-menu" v-bind="slotData"></slot>-->
        </ul>
        <ul class="navbar-nav jipvio-ul">
          <li class="jipvio-main-menu jipvio-room-btn ml-20">
            <a class="" href="#" @click="validate()">방내놓기</a>
            <!-- <router-link to="/step" class="">방내놓기</router-link> -->
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { DropDown } from "@/components";
import { CollapseTransition } from "vue2-transitions";
import NavbarToggleButton from "./NavbarToggleButton";
import { createNamespacedHelpers, mapGetters } from "vuex";
import userApi from "@/service/user";
import { Message } from "element-ui";

let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

export default {
  name: "navbar",
  props: {
    transparent: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "relative"
    },
    menuClasses: {
      type: [String, Object, Array]
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    }
  },
  provide() {
    return {
      closeNavbar: this.close
    };
  },
  components: {
    DropDown,
    CollapseTransition,
    NavbarToggleButton
  },
  data() {
    return {
      showMenu: false,
      extraNavClasses: "",
      currentScrollValue: 0
    };
  },
  computed: {
    ...sessionMapGetters({
      sessionAuthToken: "getAuthToken",
      sessionUserInfo: "getUserInfo"
    }),
    slotData() {
      return {
        toggle: this.toggle,
        open: this.open,
        close: this.close,
        isToggled: this.showMenu
      };
    },
    classes() {
      let color = `bg-${this.type}`;
      let navPosition = `navbar-${this.position}`;
      let colorOnScrollTransparent =
        this.colorOnScroll && this.currentScrollValue < this.colorOnScroll;

      if (this.position === "fixed") {
        navPosition = "fixed-top";
      }

      return [
        { "navbar-transparent": this.transparent || colorOnScrollTransparent },
        { [color]: !this.transparent && this.colorOnScroll === 0 },
        navPosition,
        this.extraNavClasses
      ];
    }
  },
  methods: {
    handleSelect(type) {
      this.$router.push({
        path: "/search/result",
        query: {
          x: 126.858330553006,
          y: 37.5017185630595,
          name: "서울 구로구 고척동 134-112",
          type: type
        }
      });
    },

    validate() {
      Message.warning("서비스 준비 중입니다. 빠른 시일 내에 서비스하겠습니다.");
      // if (this.sessionAuthToken) {
      //   if (this.sessionUserInfo.type === "LE") {
      //     Message.success("집비오에 문의해주세요.");
      //   } else {
      //     this.$router.push("/step");
      //   }
      // } else {
      //   this.$router.push("/login");
      // }
    },
    ...sessionMapActions(["setAuthToken"]),
    ...sessionMapActions(["setUserInfo"]),
    ...sessionMapActions(["clearPropertyInquiry"]),
    async logout() {
      // Kakao.Auth.logout(res => {
      //   console.log("====kakao logout res");
      //   console.log(res);
      //   console.log(Kakao.Auth.getAccessToken());
      // });

      if (this.sessionUserInfo) {
        const logoutRes = await userApi.logout();
        if (logoutRes.status === 200) {
          this.clearPropertyInquiry();
          Message.success("로그아웃 완료");
          this.setAuthToken(null);
          this.setUserInfo(null);
          this.$router.push("/");
        } else {
          Message.error(logoutRes.message);
        }
      } else {
        this.setAuthToken(null);
        this.setUserInfo(null);
      }
      this.setNav(false);
    },
    myPage() {
      // if (this.sessionUserInfo.type === "LE") {
      //   this.$router.push("/mypage/dash/normal");
      // } else if(this.sessionUserInfo.type === "AG" || this.sessionUserInfo.type === "LO"){
      //   this.$router.push("/mypage/dash/agt");
      // } else {
      //    this.$router.push("/mypage/admin/dash");
      // }
      this.$router.push("/mypage");
      this.setNav(false);
    },
    setNav(value) {
      let docClasess = document.body.classList;
      if (value) {
        docClasess.add("nav-open");
      } else {
        docClasess.remove("nav-open");
      }
      let isOpen = docClasess.contains("nav-open");
      let eventToTrigger = isOpen ? "open" : "close";
      this.showMenu = isOpen;
      this.$emit(eventToTrigger);
    },
    toggle() {
      if (this.showMenu) {
        this.$root.$emit("showSrchBar");
      } else {
        this.$root.$emit("rmvSrchBar");
      }
      this.setNav(!this.showMenu);
    },
    open() {
      this.setNav(true);
    },
    close() {
      if (this.showMenu === false) {
        return;
      }
      this.$root.$emit("showSrchBar");
      this.setNav(false);
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `bg-${this.type}`;
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    }
  },
  mounted() {
    const script = document.createElement("script");
    script.onload = () => {
      Kakao.init(process.env.VUE_APP_KKO_SDK_KEY);
      console.log(Kakao.isInitialized());
    };
    script.src = "https://developers.kakao.com/sdk/js/kakao.js";
    document.head.appendChild(script);
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
<style scoped>
nav {
  background-color: #6d4bdf !important;
  box-shadow: none !important;
}
/* .navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn) {
  color: #ffffff;
} */
</style>
